"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCELED_BECAUSE_USER_WAS_DELETED_OR_BANNED = exports.CANCELED_BY_ONFIDO_WATCHLIST_REJECTED = exports.CANCELED_BY_KOUNT_COMPLETE = exports.takerAfterAcceptance = exports.makerAfterAcceptance = exports.beforeAcceptance = void 0;
const ACCEPTANCE_TAKING_TOO_LONG = 'ACCEPTANCE_TAKING_TOO_LONG';
const REQUESTED_WRONG_AMOUNT = 'REQUESTED_WRONG_AMOUNT';
const REQUESTED_WRONG_PAYMENT_METHOD = 'REQUESTED_WRONG_PAYMENT_METHOD';
const UNACCEPTABLE_EXCHANGE_RATE = 'UNACCEPTABLE_EXCHANGE_RATE';
const USER_DOES_NOT_KNOW_HOW_TO_PROCEED = 'USER_DOES_NOT_KNOW_HOW_TO_PROCEED';
const REQUEST_CREATED_BY_MISTAKE = 'REQUEST_CREATED_BY_MISTAKE';
const OTHER = 'OTHER';
const TAKER_NOT_RESPONDING = 'TAKER_NOT_RESPONDING';
const PAYMENT_METHOD_MISMATCH = 'PAYMENT_METHOD_MISMATCH';
const HAVING_PROBLEMS_WITH_EXTERNAL_SERVICE = 'HAVING_PROBLEMS_WITH_EXTERNAL_SERVICE';
const USER_EXPERIENCING_CONNECTIVITY_ISSUES = 'USER_EXPERIENCING_CONNECTIVITY_ISSUES';
const NOT_ENOUGH_FUNDS_IN_EXTERNAL_SERVICE = 'NOT_ENOUGH_FUNDS_IN_EXTERNAL_SERVICE';
const USER_DOES_NOT_TRUST_PEER = 'USER_DOES_NOT_TRUST_PEER';
const TAKER_ACCEPTED_BY_MISTAKE = 'TAKER_ACCEPTED_BY_MISTAKE';
const MAKER_NOT_RESPONDING = 'MAKER_NOT_RESPONDING';
const DAILY_LIMIT_REACHED_IN_EXTERNAL_SERVICE = 'DAILY_LIMIT_REACHED_IN_EXTERNAL_SERVICE';
const CHARGEBACK_RISK_DECLINED = 'CHARGEBACK_RISK_DECLINED';
exports.beforeAcceptance = {
    ACCEPTANCE_TAKING_TOO_LONG,
    REQUESTED_WRONG_AMOUNT,
    REQUESTED_WRONG_PAYMENT_METHOD,
    UNACCEPTABLE_EXCHANGE_RATE,
    USER_DOES_NOT_KNOW_HOW_TO_PROCEED,
    REQUEST_CREATED_BY_MISTAKE,
    OTHER,
};
exports.makerAfterAcceptance = {
    REQUEST_CREATED_BY_MISTAKE,
    TAKER_NOT_RESPONDING,
    PAYMENT_METHOD_MISMATCH,
    HAVING_PROBLEMS_WITH_EXTERNAL_SERVICE,
    USER_EXPERIENCING_CONNECTIVITY_ISSUES,
    NOT_ENOUGH_FUNDS_IN_EXTERNAL_SERVICE,
    USER_DOES_NOT_TRUST_PEER,
    USER_DOES_NOT_KNOW_HOW_TO_PROCEED,
    CHARGEBACK_RISK_DECLINED,
    OTHER,
};
exports.takerAfterAcceptance = {
    TAKER_ACCEPTED_BY_MISTAKE,
    MAKER_NOT_RESPONDING,
    PAYMENT_METHOD_MISMATCH,
    HAVING_PROBLEMS_WITH_EXTERNAL_SERVICE,
    USER_EXPERIENCING_CONNECTIVITY_ISSUES,
    NOT_ENOUGH_FUNDS_IN_EXTERNAL_SERVICE,
    DAILY_LIMIT_REACHED_IN_EXTERNAL_SERVICE,
    USER_DOES_NOT_TRUST_PEER,
    OTHER,
};
exports.CANCELED_BY_KOUNT_COMPLETE = 'CANCELLATION_REASONS:CANCELED_BY_KOUNT_COMPLETE';
exports.CANCELED_BY_ONFIDO_WATCHLIST_REJECTED = 'CANCELLATION_REASONS:CANCELED_BY_ONFIDO_WATCHLIST_REJECTED';
exports.CANCELED_BECAUSE_USER_WAS_DELETED_OR_BANNED = 'CANCELLATION_REASONS:CANCELED_BECAUSE_USER_WAS_DELETED_OR_BANNED';
